import { render } from "./MessageList.vue?vue&type=template&id=013cc292&scoped=true"
import script from "./MessageList.vue?vue&type=script&lang=js"
export * from "./MessageList.vue?vue&type=script&lang=js"

import "./MessageList.vue?vue&type=style&index=0&id=013cc292&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-013cc292"

export default script